export const LOCALES = {
    ENUS: "en-US",
    KOKR: "ko-KR",
    VIVN: "vi-VN",
}